<template>
    <div class="bottom">
    <div class="btm-left">
      <!-- 联系我们 -->
      <div class="contect-us">
        <img class="arrow-right-cu" src="https://oss.turingsenseai.com/1598319555268087579.png" alt="">
        <div>{{$t('message.contact_us')}}</div>
      </div>
      <div class="btm-left-btm">
        <div>{{$t('message.company_name')}}</div>
        <div>{{$t('message.address')}}</div>
        <!-- <div>{{$t('message.tel')}}</div> -->
        <div>{{$t('message.Email')}}</div>
        <!-- <div>商务合作: 唐先生电话 18088886076</div> -->
        <div>{{$t('message.Cooperation')}}</div>
      </div>
    </div>
    <div class="btm-right">
      <!-- 关注我们 -->
      <div class="contect-us" style="text-align: left;">
        <img class="arrow-right-cu" src="https://oss.turingsenseai.com/1598319555268087579.png" alt="">
        <div>{{$t('message.subscribe')}}</div>
      </div>
      <div style="display: flex;margin-top:12px">

        <div class="attention-box">
          <div class="attention-img-box">
            <img class="attention-img" src="https://oss.turingsenseai.com/1598320124348212638.png" alt="">
          </div>
          <div class="attention-text">{{$t('message.wechat_official_account')}}</div>
        </div>

        <div class="attention-box">
          <div class="attention-img-box">
            <img class="attention-img" src="https://oss.turingsenseai.com/1598320108454420164.png" alt="">
          </div>
          <div class="attention-text">{{$t('message.wechat_mini_program')}}</div>
        </div>

        <div class="attention-box" style="margin-right: 12px">
          <div class="attention-img-box">
            <img class="attention-img" src="https://oss.turingsenseai.com/1598320098536035154.png" alt="">
          </div>
          <div class="attention-text">{{$t('message.sina_weibo')}}</div>
        </div>
      </div>
    </div>
    <div class="btm-line"></div>
    <div class="btm">
      {{$t('message.copyright')}}
      {{$t('message.copyright_code')}}
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {}
  },
  watch: {},
  computed: {},
  methods: {},
  created () {},
  mounted () {}
}
</script>
<style lang="scss" scoped>
.bottom{
  width:100%;
  height:380px;
  background:#2C3775;
  position: relative;
  .btm-left{
    position: absolute;
    text-align: left;
    top: 13.68%;
    left: 18.75%;
    display: flex;
    flex-direction: column;
    .btm-left-btm{
      font-size:12px;
      font-family:Microsoft YaHei;
      font-weight:400;
      line-height:30px;
      color:rgba(249,249,249,1);
    }
  }
  // 公用
  .contect-us{
    font-size:20px;
    font-family:PingFang SC;
    font-weight:600;
    line-height:12px;
    color:rgba(255,255,255,1);
    margin-bottom: 12px;
    display: flex;
  }
  .arrow-right-cu{
    width: 12px;
    height: 12px;
    margin-right: 8px;
  }
  .attention-box{
    display: flex;
    flex-direction: column;
    margin-right: 12px;
    width: 100px;
    .attention-img-box{
      .attention-img{
        width: 91px;
        height: 91px;
        margin-bottom: 6px;
      }
    }
    .attention-text{
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color:rgba(255,255,255,1);
    }
  }

  .btm-right{
    position: absolute;
    top: 13.68%;
    right: 18.75%;
    display: flex;
    flex-direction: column;
  }
  .btm-line{
    width: 62.5%;
    height: 0px;
    border: 1px solid rgba(255,255,255,.1);
    opacity: 1;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 134px;
  }
  .btm{
    position: absolute;
    bottom: 60px;
    width: 362px;
    height: 40px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 18px;
    color: rgba(249,249,249,1);
    opacity: 1;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
